import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { isAuthenticated, clearSession } from '../services/session';
import { PUBLIC_ROUTES } from '../config/app.config';

const useAuthGuard = () => {
    const history = useHistory();
    const { pathname } = useLocation();

    useEffect(() => {
        if (pathname === '/logout') {
            clearSession();
            return;
        }

        if (!isAuthenticated()) {
            clearSession();
            history.push('/sign-in');
            return;
        }

        if (PUBLIC_ROUTES.includes(pathname)) {
            history.push('/home');
        }
    }, [pathname, history]);
};

export default useAuthGuard;
